<!-- 製造会社の一覧。サプライヤーが設定される想定(サブ組ベンダーも含む) -->
<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="companyText"
    item-value="companyCd"
    :label="label"
    :disabled="disabledComputed"
    :loading="loading"
    :required="required"
    @change="onChange"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'ManufacturerInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0057')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    disabledComputed: {
      get() {
        return this.disabled || this.$store.getters.canOQCOnly
      },
    },
  },

  methods: {
    onChange(e) {
      this.$emit('change', e)
    },
  },

  async mounted() {
    this.loading = true
    try {
      const params = {
        companyCd: this.$store.getters.companyCd,
        validOnly: this.validOnly,
      }

      const elements = await API.get('/master/associateCompanies', params)
      elements.forEach((element) => {
        element['companyText'] = element['companyCd'] + ' : ' + element['companyName']
        this.items.push(element)
      })

      if (this.$store.getters.canOQCOnly) {
        this.model = this.$store.getters.companyCd
      }
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0002') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
